/**
 * return a new map with values transformed by the given transformer function
 * @param map
 * @param transformer
 * @returns {Map<any, any>}
 */ const $96cdf72cf80051f3$export$5f7754d40b4c8f37 = (map, transformer)=>{
    const newMap = new Map();
    map.forEach((value, key)=>newMap.set(key, transformer(value)));
    return newMap;
};



class $75ec954d56821735$export$e6146407f9786668 {
    _status;
    _numberOfRounds;
    _players;
    constructor(status, numberOfRounds, players){
        this._status = status;
        this._numberOfRounds = numberOfRounds;
        this._players = players;
    }
    get numberOfRounds() {
        return this._numberOfRounds;
    }
    get players() {
        return this._players;
    }
    wasGameStarted() {
        return this._status === (0, $754ec3dd285757d1$export$ed6c8a48d43208c5);
    }
    static NAME = "game-started";
}
class $75ec954d56821735$export$d25857669b05f70e {
    _status;
    constructor(status){
        this._status = status;
    }
    get status() {
        return this._status;
    }
    static NAME = "game-finished";
}
class $75ec954d56821735$export$1f6b438b3965aac0 {
    _players;
    constructor(players){
        this._players = players;
    }
    get players() {
        return this._players;
    }
    static NAME = "player-registered";
}
class $75ec954d56821735$export$ac9d7d226ba73f92 {
    _players;
    constructor(players){
        this._players = players;
    }
    get players() {
        return this._players;
    }
    static NAME = "player-removed";
}
class $75ec954d56821735$export$f20a3d14e0971251 {
    _status;
    _guesses;
    _round;
    constructor(status, guesses, round){
        this._status = status;
        this._guesses = guesses;
        this._round = round;
    }
    get status() {
        return this._status;
    }
    get guesses() {
        return this._guesses;
    }
    get round() {
        return this._round;
    }
    static NAME = "guesses-submitted";
}
class $75ec954d56821735$export$8a4901a0cc79dd96 {
    _tricksTotal;
    constructor(tricksTotal){
        this._tricksTotal = tricksTotal;
    }
    static NAME = "round-started";
}
class $75ec954d56821735$export$7cb6f085f6bc4d31 {
    _status;
    _scores;
    _round;
    constructor(status, scores, round){
        this._status = status;
        this._scores = scores;
        this._round = round;
    }
    get status() {
        return this._status;
    }
    get scores() {
        return this._scores;
    }
    get round() {
        return this._round;
    }
    static NAME = "round-finished";
}


class $ed56b5c0851a1793$export$7a872ecb27ac8565 {
    _player;
    _guess;
    constructor(player, guess){
        this._player = player;
        this._guess = guess;
    }
    get player() {
        return this._player;
    }
    get guess() {
        return this._guess;
    }
}


const $09bd50df7b2517fe$var$SUCCESS_BASE_POINTS = 20;
const $09bd50df7b2517fe$var$SUCCESS_ADD_POINTS = 10;
const $09bd50df7b2517fe$var$FAILURE_POINTS = -10;
class $09bd50df7b2517fe$export$6735cf84ecd2736 {
    _player;
    _score;
    constructor(player, score){
        this._player = player;
        this._score = score;
    }
    static fromTricksAndGuess(player, tricks, guess) {
        let score;
        if (tricks === guess) score = $09bd50df7b2517fe$var$SUCCESS_BASE_POINTS + tricks * $09bd50df7b2517fe$var$SUCCESS_ADD_POINTS;
        else {
            const difference = tricks > guess ? tricks - guess : guess - tricks;
            score = difference * $09bd50df7b2517fe$var$FAILURE_POINTS;
        }
        return new $09bd50df7b2517fe$export$6735cf84ecd2736(player, score);
    }
    get player() {
        return this._player;
    }
    get score() {
        return this._score;
    }
    add(otherScore) {
        return new $09bd50df7b2517fe$export$6735cf84ecd2736(this._player, this._score + otherScore.score);
    }
}


class $d1d06dc99b0a3a15$export$3b1a82b69663c37c {
    _player;
    _tricks;
    constructor(player, tricks){
        this._player = player;
        this._tricks = tricks;
    }
    get player() {
        return this._player;
    }
    get tricks() {
        return this._tricks;
    }
    calculateScore(guess) {
        return (0, $09bd50df7b2517fe$export$6735cf84ecd2736).fromTricksAndGuess(this._player, this._tricks, guess.guess);
    }
}


const $651b9194ff09981f$export$3e34686dc5bfb628 = "GUESSING";
const $651b9194ff09981f$export$653a7ccc7d91cd0c = "GUESSED";
const $651b9194ff09981f$export$c2e112320e14d443 = "FINISHED";
class $651b9194ff09981f$export$c5ed3eef16c0612f {
    _status = $651b9194ff09981f$export$3e34686dc5bfb628;
    _roundNumber = 1;
    _tricksTotal = 1;
    _players = new Set();
    _guesses = new Map();
    _results = new Map();
    _events = [];
    _scores = new Map();
    constructor(players){
        this._players = new Set(players);
    }
    next() {
        const round = new $651b9194ff09981f$export$c5ed3eef16c0612f(this._players);
        round._roundNumber = this._roundNumber + 1;
        round._tricksTotal = round._roundNumber;
        round._scores = this._scores;
        round._addEvent(new (0, $75ec954d56821735$export$8a4901a0cc79dd96)(round._tricksTotal));
        return round;
    }
    releaseEvents() {
        const events = this._events;
        this._events = [];
        return events;
    }
    submitGuesses(guesses) {
        if (this._status !== $651b9194ff09981f$export$3e34686dc5bfb628) throw Error("cannot guess round in status " + this._status);
        const containsNegativeGuesses = (guesses)=>guesses.find((guess)=>guess.guess < 0);
        if (containsNegativeGuesses(guesses)) throw Error("cannot add negative guesses");
        guesses.forEach((guess)=>{
            this._guesses.set(guess.player, new (0, $ed56b5c0851a1793$export$7a872ecb27ac8565)(guess.player, Number(guess.guess)));
        });
        if (!this._assertAllGuessesHaveBeenSet()) throw Error("not all guesses have been set");
        if (!this._assertGuessesDontMatchTotalTricks()) throw Error("guesses must not match total tricks");
        this._status = $651b9194ff09981f$export$653a7ccc7d91cd0c;
        this._addEvent(new (0, $75ec954d56821735$export$f20a3d14e0971251)(this._status, (0, $96cdf72cf80051f3$export$5f7754d40b4c8f37)(this._guesses, (guess)=>guess.guess), this._roundNumber));
    }
    enterResults(results, wasBombCardPlayed) {
        if (this._status !== $651b9194ff09981f$export$653a7ccc7d91cd0c) throw Error("cannot add player result when status is " + this._status);
        if (wasBombCardPlayed) this._bombCardWasPlayed();
        const containsNegativeTricks = (results)=>results.find((result)=>result.tricks < 0);
        if (containsNegativeTricks(results)) throw Error("cannot add player results with negative tricks");
        results.forEach((result)=>{
            this._results.set(result.player, new (0, $d1d06dc99b0a3a15$export$3b1a82b69663c37c)(result.player, Number(result.tricks)));
        });
        if (!this._assertAllResultsHaveBeenSet()) throw Error("not all player results have been entered");
        if (!this._assertResultsMatchTotalTricks(wasBombCardPlayed)) throw Error("results must match total tricks");
        this._calculateScores();
        this._status = $651b9194ff09981f$export$c2e112320e14d443;
        this._addEvent(new (0, $75ec954d56821735$export$7cb6f085f6bc4d31)(this._status, (0, $96cdf72cf80051f3$export$5f7754d40b4c8f37)(this._scores, (score)=>score.score), this._roundNumber));
    }
    _calculateScores() {
        const scores = new Map();
        this._results.forEach((result)=>{
            const playersGuess = this._guesses.get(result.player);
            const playersScore = result.calculateScore(playersGuess);
            scores.set(result.player, playersScore);
        });
        this._scores = [
            Array.from(this._scores.values()),
            Array.from(scores.values())
        ].flatMap((scores)=>scores).reduce((playerScores, score)=>{
            if (playerScores.has(score.player)) score = playerScores.get(score.player).add(score);
            playerScores.set(score.player, score);
            return playerScores;
        }, new Map());
    }
    _bombCardWasPlayed() {
        this._tricksTotal--;
    }
    _assertAllGuessesHaveBeenSet() {
        return this._players.size === this._guesses.size;
    }
    _assertGuessesDontMatchTotalTricks() {
        return this._tricksTotal !== Array.from(this._guesses.values()).reduce((previousValue, currentValue)=>previousValue + currentValue.guess, 0);
    }
    _assertAllResultsHaveBeenSet() {
        return this._players.size === this._results.size;
    }
    _assertResultsMatchTotalTricks() {
        return this._tricksTotal === Array.from(this._results.values()).reduce((previousValue, currentValue)=>previousValue + currentValue.tricks, 0);
    }
    _addEvent(event) {
        this._events.push(event);
    }
}



const $754ec3dd285757d1$var$CARDS_COUNT = 60;
const $754ec3dd285757d1$export$ad2c46d690f25682 = "GAME_PENDING";
const $754ec3dd285757d1$export$ed6c8a48d43208c5 = "GAME_STARTED";
const $754ec3dd285757d1$export$891ee8c777c2c512 = "GAME_FINISHED";
class $754ec3dd285757d1$export$985739bfa5723e08 {
    _status = $754ec3dd285757d1$export$ad2c46d690f25682;
    _id;
    _rounds = [];
    _players = new Set();
    _eventListeners = new Map();
    constructor(id){
        this._id = id;
        this.addEventListener((0, $75ec954d56821735$export$7cb6f085f6bc4d31).NAME, this._onRoundFinished.bind(this));
    }
    registerPlayer(player) {
        if (this._status !== $754ec3dd285757d1$export$ad2c46d690f25682) throw Error("could not add player to running game");
        if (this._maximumAmountOfPlayersWasReached()) throw Error("maximum amount of players was reached");
        if (this._players.has(player)) throw Error("could not add player twice");
        this._players.add(player);
        this._fireEvent(new (0, $75ec954d56821735$export$1f6b438b3965aac0)([
            ...this._players
        ]));
    }
    removePlayer(player) {
        if (this._status !== $754ec3dd285757d1$export$ad2c46d690f25682) throw Error("could not remove player from running game");
        if (!this._players.has(player)) throw Error("could not remove non-existent player");
        this._players.delete(player);
        this._fireEvent(new (0, $75ec954d56821735$export$ac9d7d226ba73f92)([
            ...this._players
        ]));
    }
    start() {
        if (!this._assertMinimumAmountOfPlayers()) throw Error("could not start game since there are not enough players");
        this._rounds.push(new (0, $651b9194ff09981f$export$c5ed3eef16c0612f)(this._players));
        this._status = $754ec3dd285757d1$export$ed6c8a48d43208c5;
        this._fireEvent(new (0, $75ec954d56821735$export$e6146407f9786668)(this._status, this._numberOfRounds(), this._players));
    }
    submitGuesses(guesses) {
        const round = this._currentRound();
        round.submitGuesses(guesses);
        round.releaseEvents().forEach(this._fireEvent.bind(this));
    }
    enterResults(results, wasBombCardPlayed) {
        try {
            const round = this._currentRound();
            round.enterResults(results, wasBombCardPlayed);
            round.releaseEvents().forEach(this._fireEvent.bind(this));
        } catch (e) {
            throw e;
        }
    }
    addEventListener(event, listener) {
        if (!this._eventListeners.has(event)) this._eventListeners.set(event, []);
        this._eventListeners.get(event).push(listener);
    }
    _onRoundFinished() {
        if (this._haveAllRoundsBeenPlayed()) {
            this._status = $754ec3dd285757d1$export$891ee8c777c2c512;
            this._fireEvent(new (0, $75ec954d56821735$export$d25857669b05f70e)(this._status));
        } else {
            const nextRound = this._currentRound().next();
            this._rounds.push(nextRound);
            nextRound.releaseEvents().forEach(this._fireEvent.bind(this));
        }
    }
    _fireEvent(event) {
        if (!this._eventListeners.has(event.constructor.NAME)) {
            console.debug("no listener was listening on event " + event.constructor.NAME);
            return;
        }
        this._eventListeners.get(event.constructor.NAME).forEach((listener)=>listener(event));
    }
    _assertMinimumAmountOfPlayers() {
        return this._players.size > 1;
    }
    _maximumAmountOfPlayersWasReached() {
        return this._players.size >= 6;
    }
    _haveAllRoundsBeenPlayed() {
        return this._rounds.length >= this._numberOfRounds();
    }
    _currentRound() {
        return this._rounds[this._rounds.length - 1];
    }
    _numberOfRounds() {
        return $754ec3dd285757d1$var$CARDS_COUNT / this._players.size;
    }
}



const $109525495c826c9f$var$template = document.createElement("template");
$109525495c826c9f$var$template.innerHTML = `
<form class="register-player" action="">
    <input type="text" name="name" placeholder="Player name">
    <button type="submit">Add player</button>
</form>

<div class="error-container"></div>

<ul class="registered-players">
</ul>
`;
const $109525495c826c9f$var$playerTemplate = document.createElement("template");
$109525495c826c9f$var$playerTemplate.innerHTML = `
    <li class="player">
        <form class="remove-player" action="">
            <button type="submit">X</button>     
        </form>
    </li>
`;
class $109525495c826c9f$export$f33f4ee571579482 extends HTMLElement {
    _game;
    _form;
    _errorContainer;
    _playerList;
    constructor(game){
        super();
        this._game = game;
    }
    connectedCallback() {
        this.appendChild($109525495c826c9f$var$template.content.cloneNode(true));
        this._form = this.querySelector(".register-player");
        this._playerList = this.querySelector(".registered-players");
        this._errorContainer = this.querySelector(".error-container");
        this._game.addEventListener((0, $75ec954d56821735$export$1f6b438b3965aac0).NAME, (event)=>{
            this._redrawPlayersList(event.players);
            this.querySelector("input").value = "";
        });
        this._game.addEventListener((0, $75ec954d56821735$export$ac9d7d226ba73f92).NAME, (event)=>{
            this._redrawPlayersList(event.players);
        });
        this._form.addEventListener("submit", (event)=>{
            event.preventDefault();
            this._hideError();
            const data = new FormData(this._form);
            this._registerPlayer(data);
        });
    }
    _registerPlayer(formData) {
        const playerName = formData.get("name");
        if (!playerName) {
            this._drawError("player name must not be empty");
            return;
        }
        try {
            this._game.registerPlayer(playerName);
        } catch (e) {
            this._drawError(e);
        }
    }
    _removePlayer(playerName) {
        try {
            this._game.removePlayer(playerName);
        } catch (e) {
            this._drawError(e);
        }
    }
    _drawError(message) {
        this._errorContainer.replaceChildren(document.createTextNode(message));
        this._errorContainer.style.display = "block";
    }
    _hideError() {
        this._errorContainer.style.display = "none";
    }
    _redrawPlayersList(players) {
        const list = new DocumentFragment();
        players.map((player)=>{
            const playerElement = $109525495c826c9f$var$playerTemplate.content.cloneNode(true);
            const li = playerElement.querySelector(".player");
            li.insertBefore(this.ownerDocument.createTextNode(player), li.firstChild);
            const form = playerElement.querySelector("form");
            form.addEventListener("submit", (event)=>{
                event.preventDefault();
                this._removePlayer(player);
            });
            return playerElement;
        }).forEach((element)=>list.appendChild(element));
        this._playerList.replaceChildren(list);
    }
}
customElements.define("add-player", $109525495c826c9f$export$f33f4ee571579482);


const $730c1bcafa115da5$var$template = document.createElement("template");
$730c1bcafa115da5$var$template.innerHTML = `
    <section>
        <div class="error-container"></div>
        <form class="start-game-form" action="">
            <button type="submit">Start game</button>
        </form>
    </section>
`;
class $730c1bcafa115da5$export$e75c2eefe49598ef extends HTMLElement {
    _game;
    _form;
    _errorContainer;
    constructor(game){
        super();
        this._game = game;
    }
    connectedCallback() {
        this.appendChild($730c1bcafa115da5$var$template.content.cloneNode(true));
        this._form = this.querySelector(".start-game-form");
        this._errorContainer = this.querySelector(".error-container");
        this._form.addEventListener("submit", (event)=>{
            event.preventDefault();
            this._hideError();
            try {
                this._game.start();
            } catch (e) {
                this._drawError(e);
            }
        });
    }
    _drawError(message) {
        this._errorContainer.replaceChildren(document.createTextNode(message));
        this._errorContainer.style.display = "block";
    }
    _hideError() {
        this._errorContainer.style.display = "none";
    }
}
customElements.define("start-game", $730c1bcafa115da5$export$e75c2eefe49598ef);


const $4eb1bfc11325373a$var$template = document.createElement("template");
$4eb1bfc11325373a$var$template.innerHTML = `
    <div class="error-container"></div>
    <form class="submit-guesses-form" action="">
        <button type="submit">Submit guesses</button>
    </form>
`;
const $4eb1bfc11325373a$var$playerTemplate = document.createElement("template");
$4eb1bfc11325373a$var$playerTemplate.innerHTML = `
    <label>Player name</label>
    <input type="number" name="player" min="0" value="0">
`;
class $4eb1bfc11325373a$export$82dc8338acc43598 extends HTMLElement {
    _game;
    _players;
    _form;
    _errorContainer;
    constructor(game, players){
        super();
        this._game = game;
        this._players = players;
    }
    connectedCallback() {
        this.appendChild($4eb1bfc11325373a$var$template.content.cloneNode(true));
        this._form = this.querySelector(".submit-guesses-form");
        this._errorContainer = this.querySelector(".error-container");
        this._drawForm();
        this._form.addEventListener("submit", (event)=>{
            event.preventDefault();
            this._hideError();
            this._submitGuesses(new FormData(this._form));
        });
    }
    _drawForm() {
        const wrapper = document.createDocumentFragment();
        this._players.forEach((player)=>{
            const element = $4eb1bfc11325373a$var$playerTemplate.content.cloneNode(true);
            element.querySelector("label").replaceChildren(document.createTextNode(player));
            element.querySelector("input").name = player;
            wrapper.appendChild(element);
        });
        this._form.insertBefore(wrapper, this._form.firstChild);
    }
    _drawError(message) {
        this._errorContainer.replaceChildren(document.createTextNode(message));
        this._errorContainer.style.display = "block";
    }
    _hideError() {
        this._errorContainer.style.display = "none";
    }
    _submitGuesses(form) {
        try {
            const guesses = Array.from(this._players).map((player)=>({
                    player: player,
                    guess: form.get(player)
                }));
            this._game.submitGuesses(guesses);
        } catch (e) {
            this._drawError(e);
        }
    }
}
customElements.define("submit-guesses", $4eb1bfc11325373a$export$82dc8338acc43598);


const $bc042d654274180f$var$template = document.createElement("template");
$bc042d654274180f$var$template.innerHTML = `
    <div class="error-container"></div>
    <form class="enter-results-form" action="">
        <label class="checkbox">
            <input type="checkbox" name="bomb_played" value="1">
            Bomb card was played
        </label>
        <button type="submit">Enter results</button>
    </form>
`;
const $bc042d654274180f$var$playerTemplate = document.createElement("template");
$bc042d654274180f$var$playerTemplate.innerHTML = `
    <label>Player name</label>
    <input type="number" name="player" min="0" value="0">
`;
class $bc042d654274180f$export$e05718592c5005b3 extends HTMLElement {
    _game;
    _players;
    _form;
    _errorContainer;
    constructor(game, players){
        super();
        this._game = game;
        this._players = players;
    }
    connectedCallback() {
        this.appendChild($bc042d654274180f$var$template.content.cloneNode(true));
        this._form = this.querySelector(".enter-results-form");
        this._errorContainer = this.querySelector(".error-container");
        this._drawForm();
        this._form.addEventListener("submit", (event)=>{
            event.preventDefault();
            this._hideError();
            this._enterResults(new FormData(this._form));
        });
    }
    _drawForm() {
        const wrapper = document.createDocumentFragment();
        this._players.forEach((player)=>{
            const element = $bc042d654274180f$var$playerTemplate.content.cloneNode(true);
            element.querySelector("label").replaceChildren(document.createTextNode(player));
            element.querySelector("input").name = player;
            wrapper.appendChild(element);
        });
        this._form.insertBefore(wrapper, this._form.querySelector("button"));
    }
    _drawError(message) {
        this._errorContainer.replaceChildren(document.createTextNode(message));
        this._errorContainer.style.display = "block";
    }
    _hideError() {
        this._errorContainer.style.display = "none";
    }
    _enterResults(form) {
        try {
            const results = Array.from(this._players).map((player)=>({
                    player: player,
                    tricks: form.get(player)
                }));
            const wasBombPlayed = form.get("bomb_played") === "1";
            this._game.enterResults(results, wasBombPlayed);
        } catch (e) {
            this._drawError(e);
        }
    }
}
customElements.define("enter-results", $bc042d654274180f$export$e05718592c5005b3);



const $b71bd4801b5de8cb$var$template = document.createElement("template");
$b71bd4801b5de8cb$var$template.innerHTML = `
    <section class="score-board">
        <table>
        <thead>
            <tr class="scoreboard-players">
                <th class="round-number">#</th>
            </tr>    
        </thead>
        <tbody>
            
        </tbody>
        </table>
    </section>
    
    <section class="actions"></section>
`;
const $b71bd4801b5de8cb$var$playerTemplate = document.createElement("template");
$b71bd4801b5de8cb$var$playerTemplate.innerHTML = `
    <th class="player" colspan="2"></th>
`;
const $b71bd4801b5de8cb$var$roundTemplate = document.createElement("template");
$b71bd4801b5de8cb$var$roundTemplate.innerHTML = `
    <tr>
        <th class="round-number"></th>
    </tr>
`;
const $b71bd4801b5de8cb$var$scoreTemplate = document.createElement("template");
$b71bd4801b5de8cb$var$scoreTemplate.innerHTML = `
    <td class="score"></td>
    <td class="guess"></td>
`;
class $b71bd4801b5de8cb$export$e9d1f91e7d7d611a extends HTMLElement {
    _game;
    _players;
    _numberOfRounds;
    _head;
    _body;
    _actionsContainer;
    _roundElements = [];
    constructor(game, numberOfRounds, players){
        super();
        this._game = game;
        this._numberOfRounds = numberOfRounds;
        this._players = players;
    }
    connectedCallback() {
        this.appendChild($b71bd4801b5de8cb$var$template.content.cloneNode(true));
        this._head = this.querySelector(".scoreboard-players");
        this._body = this.querySelector("tbody");
        this._actionsContainer = this.querySelector(".actions");
        this._drawHead();
        this._drawBody();
        this._actionsContainer.replaceChildren(new (0, $4eb1bfc11325373a$export$82dc8338acc43598)(this._game, this._players));
        this._game.addEventListener((0, $75ec954d56821735$export$f20a3d14e0971251).NAME, (event)=>{
            this._actionsContainer.replaceChildren(new (0, $bc042d654274180f$export$e05718592c5005b3)(this._game, this._players));
            this._drawGuessesForRound(event.round, event.guesses);
        });
        this._game.addEventListener((0, $75ec954d56821735$export$8a4901a0cc79dd96).NAME, ()=>{
            this._actionsContainer.replaceChildren(new (0, $4eb1bfc11325373a$export$82dc8338acc43598)(this._game, this._players));
        });
        this._game.addEventListener((0, $75ec954d56821735$export$7cb6f085f6bc4d31).NAME, (event)=>{
            this._drawScoresForRound(event.round, event.scores);
        });
        this._game.addEventListener((0, $75ec954d56821735$export$d25857669b05f70e).NAME, ()=>{
            this._actionsContainer.replaceChildren();
        });
    }
    _drawHead() {
        this._players.forEach((player)=>{
            const element = $b71bd4801b5de8cb$var$playerTemplate.content.cloneNode(true);
            element.querySelector("th").appendChild(document.createTextNode(player));
            this._head.appendChild(element);
        });
    }
    _drawBody() {
        for(let i = 0; i < this._numberOfRounds; i++){
            const roundElement = $b71bd4801b5de8cb$var$roundTemplate.content.cloneNode(true);
            roundElement.querySelector("th").appendChild(document.createTextNode((i + 1).toString()));
            this._players.forEach((player)=>{
                const scoreElement = $b71bd4801b5de8cb$var$scoreTemplate.content.cloneNode(true);
                scoreElement.querySelectorAll("td").forEach((el)=>el.dataset.player = player);
                roundElement.querySelector("tr").appendChild(scoreElement);
            });
            this._roundElements.push(roundElement.querySelector("tr"));
            this._body.appendChild(roundElement);
        }
    }
    _drawGuessesForRound(roundNumber, guesses) {
        const roundElement = this._roundElements[roundNumber - 1];
        this._players.forEach((player)=>{
            const playerElement = roundElement.querySelector(`td[data-player=${player}].guess`);
            const guess = guesses.has(player) ? guesses.get(player) : "";
            playerElement.replaceChildren(document.createTextNode(guess));
        });
    }
    _drawScoresForRound(roundNumber, scores) {
        const roundElement = this._roundElements[roundNumber - 1];
        this._players.forEach((player)=>{
            const playerElement = roundElement.querySelector(`td[data-player=${player}].score`);
            const score = scores.has(player) ? scores.get(player) : "";
            playerElement.replaceChildren(document.createTextNode(score));
        });
    }
}
customElements.define("score-board", $b71bd4801b5de8cb$export$e9d1f91e7d7d611a);



class $bf8864a5b1388025$var$ScoreKeeperComponent extends HTMLElement {
    _game;
    _playerArea;
    _gameArea;
    constructor(){
        super();
    }
    connectedCallback() {
        this._game = new (0, $754ec3dd285757d1$export$985739bfa5723e08)("id");
        this._playerArea = this.getElementsByClassName("player-area")[0];
        if (!this._playerArea) console.error("could not initialize Wizard Score Keeper: Could not find player area (.player-area)");
        this._playerArea.replaceChildren(new (0, $109525495c826c9f$export$f33f4ee571579482)(this._game));
        this._gameArea = this.getElementsByClassName("game-area")[0];
        if (!this._playerArea) console.error("could not initialize Wizard Score Keeper: Could not find game area (.game-area)");
        this._gameArea.replaceChildren(new (0, $730c1bcafa115da5$export$e75c2eefe49598ef)(this._game));
        this._game.addEventListener((0, $75ec954d56821735$export$e6146407f9786668).NAME, (event)=>{
            this._playerArea.style.display = "none";
            this._gameArea.replaceChildren(new (0, $b71bd4801b5de8cb$export$e9d1f91e7d7d611a)(this._game, event.numberOfRounds, event.players));
        });
        console.log("wizard score keeper initialized");
    }
}
customElements.define("wizard-score-keeper", $bf8864a5b1388025$var$ScoreKeeperComponent);


//# sourceMappingURL=index.84450094.js.map
